import React from 'react';
import { ActiveStatusIcon } from './ActiveStatusIcon';

interface StatusToggleProps {
  value: string;
  item: any;
  onToggle: (id: string, isActive: boolean) => void | Promise<void>;
}

export const StatusToggle: React.FC<StatusToggleProps> = ({ value, item, onToggle }) => {
  const isActive = (value || '').toUpperCase() === 'ACTIVE';

  return (
    <ActiveStatusIcon
      status={value}
      onToggle={() => onToggle(item.id, !isActive)}
    />
  );
};
